import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import {Field, Form, Formik} from "formik";
import CurrencyInput from "../global/CurrencyInput";
import * as Yup from "yup";
import DatePicker from 'react-datepicker';
import TransactionModel from '../../models/TransactionModel';
import AppNotification from "../../helpers/AppNotification";
import Swal from "sweetalert2";
import "./ModalTransactionEdit.css";

function  ModalTransactionEdit(props) {
    const validationSchema = Yup.object().shape({
        recipient_name: Yup.string().required('Không được để trống!'),
        from_number: Yup.string().required('Không được để trống!'),
        amount: Yup.string().required('Không được để trống!'),
        note: Yup.string().required('Không được để trống!'),
        date_time: Yup.string().required('Không được để trống!'),
        transaction_code: Yup.string().required('Không được để trống!'),
    });

    const [initialValues, setInitialValues] = useState({
        id: '',
        recipient_name: '',
        from_number: '',
        amount: '',
        note: '',
        created_at: '',
        date_time: '',
        transaction_code: '',
    });

    useEffect(() => {
        if (props.data) {
            setInitialValues({
                id: props.data.id,
                recipient_name: props.data.recipient_name,
                from_number: props.data.from_number,
                transaction_code: props.data.transaction_code,
                amount: props.data.amount,
                note: props.data.transaction_note || props.data.note,
                created_at: props.data.created_at,
                date_time: new Date(props.data.created_at || Date.now())
            });
        }
    }, [props.data]);

    const handleInputChange = (event) => {
        const {name, value} = event.target;

        setInitialValues((prevInitialValues) => ({
            ...prevInitialValues,
            [name]: value,
        }));
    };

    const handleInputDatetime = (date) => {
        setInitialValues((prevInitialValues) => ({
            ...prevInitialValues,
            ['date_time']: date,
        }));
    };

    const onSubmit = (values) => {
        TransactionModel.updateHistory(values).then((res) => {
            if (res.success == true) {
                Swal.fire({
                    icon: "success",
                    title: "Cập nhật thành công!",
                    showConfirmButton: true,
                    timer: 2000,
                }).then((result) => {
                    props.onHideReload();
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: res.data,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        }).catch((err) => {
            console.log(err);
            AppNotification.showError('Lấy dữ liệu thất bại!');
        })
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="bg-grey">
                <Modal.Title id="contained-modal-title-vcenter">
                    Sửa thông tin giao dịch
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-grey">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ errors, touched , setFieldValue}) => (
                        <Form>
                            <div>
                                <label htmlFor="content">Tên người nhận:</label>
                                <Field className="form-control" type="text" id="recipient_name" name="recipient_name"
                                       value={initialValues.recipient_name} onChange={(e) => handleInputChange(e)}/>
                                {errors.recipient_name ? (
                                    <div className="mt-1" style={{color: 'red'}}>{errors.recipient_name}</div>
                                ) : null}
                            </div>
                            <div className="mt-2">
                                <label htmlFor="content">STK người nhận:</label>
                                <Field className="form-control" type="text" id="from_number" name="from_number"
                                       value={initialValues.from_number} onChange={(e) => handleInputChange(e)}/>
                                {errors.from_number ? (
                                    <div className="mt-1" style={{color: 'red'}}>{errors.from_number}</div>
                                ) : null}
                            </div>
                            <div className="mt-2">
                                <label htmlFor="content">Mã giao dịch:</label>
                                <Field className="form-control" type="text" id="transaction_code" name="transaction_code"
                                       value={initialValues.transaction_code} onChange={(e) => handleInputChange(e)}/>
                                {errors.transaction_code ? (
                                    <div className="mt-1" style={{color: 'red'}}>{errors.transaction_code}</div>
                                ) : null}
                            </div>
                            <div className="mt-2">
                                <label htmlFor="content">Số tiền:</label>
                                <CurrencyInput
                                    type="text"
                                    name="amount"
                                    id="amount"
                                    placeholder="Số tiền giao dịch"
                                    className="form-control"
                                    value={initialValues.amount}
                                    onChange={(e) => handleInputChange(e)}
                                />
                                {errors.amount ? (
                                    <div className="mt-1" style={{color: 'red'}}>{errors.amount}</div>
                                ) : null}
                            </div>
                            <div className="mt-2">
                                <label htmlFor="content">Thời gian giao dịch:</label>
                                <div>
                                    <DatePicker
                                        selected={initialValues.date_time}
                                        name="date_time"
                                        onChange={(date) => handleInputDatetime(date)}
                                        showTimeSelect
                                        timeIntervals={30}
                                        timeCaption="Time"
                                        dateFormat="dd/MM/yyyy HH:mm:ss"
                                        timeFormat="HH:mm:ss"
                                        className="form-control"
                                    />
                                    {errors.date_time ? (
                                        <div className="mt-1" style={{color: 'red'}}>{errors.date_time}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="mt-2">
                                <label htmlFor="content">Nội dung ck:</label>
                                <Field className="form-control" type="text" id="note" name="note"
                                       value={initialValues.note} onChange={(e) => handleInputChange(e)}/>
                                {errors.note ? (
                                    <div className="mt-1" style={{color: 'red'}}>{errors.note}</div>
                                ) : null}
                            </div>

                            <div className="modal-footer bg-grey">
                                <button type="button" className="btn btn-danger" data-dismiss="modal"
                                        onClick={props.onHide}>
                                    Đóng
                                </button>
                                <button type="submit" className="btn btn-success">
                                    Cập nhật
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}

export default ModalTransactionEdit;